import { BriePages, SetBriePage } from "./BrieChatMenu";
import { ReactNode } from "react";
import BrieIcon from "./BrieIcon";
import { Badge } from "reactstrap";

const ChatGPTTitle = (
  <>
    <div
      className="d-flex justify-content-between"
      style={{
        fontSize: 13,
        lineHeight: 1.2,
        position: "absolute",
        top: 8,
        left: 50,
      }}
    >
      <div
        className="brie-icon"
        style={{ width: 30, height: 30, boxShadow: "unset", marginRight: 10 }}
      >
        <BrieIcon transform="scale(.5, .5)" />
      </div>

      <div>
        <span style={{ fontWeight: 600, fontSize: 14 }}>Brie AI Chat</span>
        <br />
        <i
          className="mdi mdi-lightning-bolt text-warning ml-4"
          style={{ fontSize: 15 }}
        />
        <div className="ml-2">Powered By Brie</div>
      </div>
    </div>
    <div style={{ position: "absolute", right: 20, top: 10 }}>
      <Badge color="primary">Beta</Badge>
    </div>
  </>
);

const titles: { [key in BriePages]: string | ReactNode } = {
  home: "GrowthCloud Assistant",
  messages: "Messages",
  "chat-feedback": "Feedback",
  "chat-gpt": ChatGPTTitle,
  support: "Help and Support",
  "voice-chat-gpt": "Recording Voice",
  "voice-chat-feedback": "Recording Voice",
};

interface HeaderProps {
  page: BriePages;
  setPage: SetBriePage;
  previousPage: BriePages | undefined;
}

const BrieChatMenuHeader = ({ page, setPage, previousPage }: HeaderProps) => {
  return (
    <div className="brie-menu-header border-superlight border-bottom">
      {page !== "home" && (
        <i className="mdi mdi-chevron-left" onClick={goBack} />
      )}
      <h3>{titles[page]}</h3>
    </div>
  );

  function goBack() {
    if (page === "chat-gpt") {
      return setPage("messages");
    }

    if (
      previousPage &&
      ["chat-feedback", "voice-chat-feedback", "voice-chat-gpt"].includes(page)
    ) {
      return setPage(previousPage);
    }

    setPage("home");
  }
};

export default BrieChatMenuHeader;
